/**
 * The CLIENT-side half of the public-route decision — the Next route patterns that render for a visitor
 * with no Wix session at all.
 *
 * `lib/public-paths.js` is the server half and answers about a request PATH (`/s/abc`); this one answers
 * about a Next ROUTE (`router.pathname`, i.e. `/s/[token]`), which is the only thing `_app` has. They
 * are deliberately two files: the server half is plain CommonJS because express-server.js cannot require
 * a Next-bundled TS module, and it matches concrete paths a crafted URL can shape, which a route pattern
 * cannot be.
 *
 * ## Why this exists at all
 * Exempting `/s/*` from the server's sign-in bounce is not enough on its own. `_app` runs
 * `useInstanceAuthBootstrap` on EVERY route: with the `symphonyInstanceAuthWeb` toggle on, it resolves
 * the signed instance and, finding no session, calls `redirectToLogin()`. On every other route that is
 * correct — every other route's reader is a Symphony user. On the share card it would put the recipient
 * in front of the same login form the server exemption exists to spare them, from the client instead of
 * the edge, and would carry the card TOKEN into the sign-in `returnUrl` on the way.
 *
 * So a public route opts out of anything that assumes a session. Adding an entry here is a security and
 * product decision, exactly as adding one to `PUBLIC_PATHS` is.
 */
export const PUBLIC_ROUTE_PREFIXES: readonly string[] = ['/s/'];

/** True when this Next route pattern renders for a visitor with no session. */
export function isPublicRoute(pathname: string | undefined | null): boolean {
  if (typeof pathname !== 'string' || !pathname) {
    return false;
  }
  return PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
